module.exports = __webpack_public_path__ + "img/logo2.a548f718.png";